import { Component, effect, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { combineLatestWith } from 'rxjs';

import { UserStateService } from '@bn/auth/stores';
import { AbstractLazyDirective } from '@bn/features/abstracts/abstract-lazy.directive';
import { SupportDepartmentType } from '@bn/primitives';
import { ModalState } from '@bn/web-ui/dialog';
import { ListWithIconItem } from '@bn/web-ui/premium-banner';

@Component({
  templateUrl: './expired-trial-modal.component.html',
  styleUrls: ['./expired-trial-modal.component.scss'],
  standalone: false,
})
export class ExpiredTrialModalComponent extends AbstractLazyDirective {
  readonly #dialog = inject<BsModalRef<ExpiredTrialModalComponent>>(BsModalRef);

  readonly #accountStore = inject(UserStateService).accountStore;
  readonly #userStore = inject(UserStateService).userStore;

  public trialBalance = 0;
  public usedTrialBalance = 0;
  public totalTrialBalance = 0;

  public data?: ModalState;
  public totalBandwidth = 0;
  public usedBandwidth = 0;
  public listData: ListWithIconItem[] = [
    {
      icon: 'circle-check',
      iconSize: 'lg',
      text: 'Speeding up your websites',
    },
    {
      icon: 'circle-check',
      iconSize: 'lg',
      text: 'Optimizing your images and static files',
    },
    {
      icon: 'circle-check',
      iconSize: 'lg',
      text: 'Delivering your videos without buffering',
    },
    {
      icon: 'circle-check',
      iconSize: 'lg',
      text: 'Storing your files in a cloud',
    },
    {
      icon: 'circle-check',
      iconSize: 'lg',
      text: 'Using an ultra-fast DNS platform',
    },
  ];

  constructor() {
    super();

    toObservable(this.#accountStore.billingTrialOverview)
      .pipe(takeUntilDestroyed(), combineLatestWith(this.route.fragment))
      .subscribe(([billingTrialOverview]) => {
        if (!billingTrialOverview) return;

        this.trialBalance = billingTrialOverview.TrialBalance;
        this.usedTrialBalance = billingTrialOverview.TrialUsage;
        this.totalTrialBalance = this.trialBalance + this.usedTrialBalance;
      });

    effect(() => {
      const user = this.#userStore.userDetails();
      if (user) {
        this.totalBandwidth = user.TrialBandwidthLimit ?? 0;
        this.usedBandwidth = user.TotalBandwidthUsed ?? 0;
      }
    });
  }

  public rechargeAcc(): void {
    this.onClose();

    this.router.navigate(['/account/billing'], {
      queryParams: {
        openRechargeModal: 'true',
      },
    });
  }

  public contactSales(): void {
    this.onClose();

    this.router.navigate(['/support/tickets/new'], {
      queryParams: {
        Department: SupportDepartmentType.Sales,
        Issue: 1,
      },
    });
  }

  public onClose(): void {
    this.#dialog.hide();
  }
}
